import React, { useEffect, useRef, useState } from "react";

import "../ProductScreen.css";
import { Link, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import Rating from "../../components/Rating";
import { useDispatch, useSelector } from "react-redux";
import {
  actionToBringInSkuPrice,
  actionToGetCampaignedProductDetails,
  actionToGetProductDetails,
  actionToGetSideProductsList,
} from "../../actions/productActions";
import MessageBox from "../../modules/shared/components/MessageBox";
import {
  actionToAddSkuItemInCart,
  actionToRemoveSkuItemInCart,
} from "../../actions/cartActions";
import { convertToUrl, scrollToTop } from "../../libraries/ercLibrary";
import ImageMagnifier from "../../components/ImageMagnifier.tsx";
import LongProductDescription from "../../components/LongProductDescription";
import MessageProductFeature from "../../components/MessageProductFeature";
import SuspenseFallback from "../../components/SuspenseFallback";
import {
  PRODUCT_SKU_COMPAIGNED_RESET,
  PRODUCT_SKU_PRICE_RESET,
} from "../../constants/productConstants";
import { actionToGetReviewsList } from "../../actions/reviewActions";
import useWidth from "../../hooks/useWidth";
import useResetLocationChange from "../../hooks/useResetLocationChange";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";
import FreeProductAddToCart from "./FreeProductAddToCart";
import ErcModal from "../../modules/shared/components/ErcModal";
import { CART_EMPTY_SKU } from "../../constants/cartConstants";
import useVariantSelection from "../../hooks/useVariantSelection";
import useVariantSelectedSku from "../../hooks/useVariantSelectedSku";
import useIsMounted from "../../hooks/useIsMounted";
import useScrollRestorationEcommerce from "../../hooks/useScrollRestorationEcommerce";
import useResetSessionStorageOnLocationChange from "../../hooks/useResetSessionStorageOnLocationChange";
import "../AdminCampaign/Campaign.css";
import { actionListQnas } from "../../actions/qnaActions";
import PurchaseComponent from "../../components/PriceOffer/PurchaseComponent";
// import useGetLimitedTimeDiscountInfo from "../../hooks/useGetLimitedTimeDiscountInfo";
// import { useHasItemInPendingOrders } from "../../hooks/useHasItemInPendingOrders";
import calculateLimitedTimeDiscountValidity from "../../utils/calculateLimitedTimeDiscountValidity";
import ShowcaseReviews from "./ShowcaseReviews";
import FrequentlyAskedQuestions from "../../components/FrequentQuestions/FrequentlyAskedQuestions";
import { useCalculateLastMonthsSales } from "../../hooks/useCalculateLastMonthsSales";
import LastMonthTotalSales from "../../components/LastMonthTotalSales/LastMonthTotalSales";
import SideProductSlideShow from "../../components/SideProducts/SideProductSlideShow";

export default function ProductScreenNew(props) {
  let productId = props.match.params.id;
  const history = useHistory();
  const dispatch = useDispatch();
  const width = useWidth();
  const sideProductsRef = useRef("");

  // PROPS COMING FROM App
  const { createdFingerPrint } = props;

  // REDUX STATE THAT HOLDS INFO IF THERE IS A PENDING ORDER OF CLIENT
  const checkIfThereIsApendingOrder = useSelector(
    (state) => state.checkIfThereIsApendingOrder
  );
  const { isPending } = checkIfThereIsApendingOrder;

  //REDUX STATE THAT HOLDS PRODUCT DETAILS
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  //REQUEST PRODUCT DETAILS FROM SERVER
  useEffect(() => {
    dispatch(actionToGetProductDetails(productId));
  }, [dispatch, productId]);

  const mountRef = useRef(false);
  const isMounted = useIsMounted(mountRef);
  useScrollRestorationEcommerce("/urun", isMounted);

  useResetLocationChange("/urun/", PRODUCT_SKU_PRICE_RESET, scrollToTop);

  // RESET SESSION STORAGE ON LOCATION CHANGE
  /* When a user rejected upsell offer or accepted an upsell offer,
  upsell modal must stay close on backbutton and refresh. It is logical that
  it should only reset if user goes to product details page. If user purchase another product,
  he/she should be entitled to see another upsell offer. Therefore l clear session storage item
  on product details page*/
  useResetSessionStorageOnLocationChange(
    "/urun/",
    "isUpsellOrderCreated",
    false // When this is true clearance is done as you enter /urun/ . If it is false or undefined, it is done when leaving the /urun/.
  );

  // Redirect the product if there is a redirectLink
  useEffect(() => {
    if (product && product.redirect && product.redirectLink) {
      history.replace(product.redirectLink);
    }
  }, [product, history]);

  // ARRAY THAT HOLDS CHOOSEN VARIANTS
  const [choosenVariants, setChoosenVariants] = useState("");

  // Returns single sku if any and fullVariantsArray
  const variants = useVariantSelection(
    loading,
    error,
    product,
    choosenVariants
  );

  // returns choosen sku
  const multiSku = useVariantSelectedSku(
    variants.fullVariantsArray,
    choosenVariants,
    product,
    actionToBringInSkuPrice
  );

  //REDUX STATE THAT HOLDS PRODUCT SKU DETAILS
  const bringInSkuPrice = useSelector((state) => state.bringInSkuPrice);
  const {
    loading: loadingSkuData,
    error: errorSkuData,
    skuData,
  } = bringInSkuPrice;

  // GET LIMITED TIME DISCOUNT INFO (remainingTime is in miliseconds)
  /*const { isDiscountValid, remainingTime } = useGetLimitedTimeDiscountInfo(
    product,
    createdFingerPrint
  );*/
  const { isDiscountValid, remainingTime } =
    calculateLimitedTimeDiscountValidity(
      product,
      createdFingerPrint?.firstVisitTime
    );

  // CHECK IF THE PRODUCT IS AVAILABLE IN PENDING ORDERS
  /*const { hasItemInPendingOrder } = useHasItemInPendingOrders(
    product,
    isPending
  );*/

  /* With this code we set prices for the choosen sku. Each sku has its own price and name.*/
  const [price, setPrice] = useState({ price: 0, priceGap: 0, name: "" });
  useEffect(() => {
    if (skuData) {
      // SET CHOOSEN SKU PRICES
      setPrice({
        price: skuData.skus[0].price,
        priceGap: skuData.skus[0].priceGap,
        timeLimitedDiscountAmount:
          skuData.skus[0].timeLimitedDiscount.discountAmount,
        name: skuData.skus[0].name,
      });
    } else if (!loading && !error && product) {
      // SET DEFAULT PRICES
      setPrice({
        price: product.defaultPrice,
        priceGap: product.defaultPriceGap,
        timeLimitedDiscountAmount: product.timeLimitedDiscount.discountAmount,
        name: product.name,
      });
    }
  }, [error, loading, product, skuData]);

  // REDUX STORE THAT HOLDS qnaList
  const listQnas = useSelector((state) => state.listQnas);
  const { qna } = listQnas;
  useEffect(() => {
    dispatch(actionListQnas(productId, "qnaCount"));
  }, [dispatch, productId]);

  //REQUEST CAMPAIGNED PRODUCT DETAILS FROM SERVER
  const campaignedProductDetails = useSelector(
    (state) => state.campaignedProductDetails
  );
  const {
    loading: loadingCampaign,
    error: errorCampaign,
    product: productCampaign,
  } = campaignedProductDetails;
  useEffect(() => {
    let timer = setTimeout(() => {
      if (product && product.buyOneGetOneFree && product.freeProductId) {
        dispatch(actionToGetCampaignedProductDetails(product.freeProductId));
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, product]);

  // IF THERE IS A CAMPAIGNED PRODUCT CHECK COUNT IN STOCK. IF THERE IS NO STOCK, DO NOT OPEN BUY ONE GET ONE FREE MODAL
  const [isCampaignedProductInStock, setIsCampaignedProductInStock] =
    useState(false);
  useEffect(() => {
    if (!loadingCampaign && !errorCampaign && productCampaign) {
      const stockNumber = productCampaign.skus
        .map((sku) => sku.countInStock)
        .reduce((a, c) => a + c, 0);
      if (stockNumber > 0) {
        setIsCampaignedProductInStock(true);
      }
    }
  }, [loadingCampaign, errorCampaign, productCampaign]);

  //REDUX STATE THAT HOLDS CART ITEMS
  const addOrRemoveSkuItemInCart = useSelector(
    (state) => state.addOrRemoveSkuItemInCart
  );
  const { cartSkuItems } = addOrRemoveSkuItemInCart;

  //REDUX STATE THAT HOLDS REVIEWS LIST
  const getReviewsList = useSelector((state) => state.getReviewsList);
  const {
    loading: loadingReviewsList,
    error: errorReviewsList,
    reviewsList,
  } = getReviewsList;
  useEffect(() => {
    dispatch(actionToGetReviewsList(productId, "all", "all"));
  }, [dispatch, productId]);

  // BRING IN SIDE PRODUCTS
  const sideProductsList = useSelector((state) => state.sideProductsList);
  const {
    loading: loadingSideProducts,
    error: errorSideProducts,
    sideProducts,
  } = sideProductsList;
  useEffect(() => {
    // CONVERT IDS ARRAY INTO STRING
    if (product?.sideProducts) {
      const idString = product.sideProducts.toString();
      dispatch(actionToGetSideProductsList(idString));
    }
  }, [dispatch, product]);

  //REACT STATES TO CREATE SKU CODE AND CART ACTIONS AND GALERY MAIN IMAGE
  const [qty, setQty] = useState(0);

  //REACT STATE THAT HOLDS GALERY IMAGES INDEX
  const [galeryLargeImage, setGaleryLargeImage] = useState(0);

  //SETTING INDEX TO COMPARE CLICKED IMAGE WITH IMAGES IN ARRAY
  function handleGaleryLargeImage(index) {
    setGaleryLargeImage(index);
  }
  /*-----------------------------------------------Add Free Product In Cart---------------------------------------------------*/
  // OPENS ErcModal IF THERE IS A FREE OFFER
  const [buyOneGetOneFreeRequested, setBuyOneGetOneFreeRequested] =
    useState(false);
  // DISABLES AddToCart BUTTON TO AVOID MULTIPLE ADS
  const [disableButton, setDisableButton] = useState(false);
  //TOGGLE OPEN/CLOSE BUY ONE GET ONE FREE MODAL FORM
  function resetCartIfFreeProductNotAddedInCart(product) {
    //REMOVES THE LAST ITEM FROM CART IF FREE ITEM VARIANTS IS NOT CHOOSEN
    const item = cartSkuItems.find((item, index) => {
      return (
        item.buyOneGetOneFree &&
        item.price > 0 &&
        index === cartSkuItems.length - 1
      );
    });
    if (item) {
      setBuyOneGetOneFreeRequested(false);
      dispatch(actionToRemoveSkuItemInCart(item.indexId));
      dispatch({ type: PRODUCT_SKU_COMPAIGNED_RESET });
      setDisableButton(false);
    }
  }

  //REACT STATES THAT MENAGES ALERT IF QTY OR VARIANTS ARE NOT CHOOSEN BEFORE HITTING ADD TO CART BUTTON
  const [variantAlert, setVariantAlert] = useState({ index: -1, message: "" });
  const [noSkuAlert, setNoSkuAlert] = useState("");
  const [qtyAlert, setQtyAlert] = useState("");

  // Add To Cart Function
  function addToCartHandler(productId, buyOneGetOneFree, discounted) {
    discounted = true;

    if (!multiSku && !variants.singleSku) {
      setNoSkuAlert("Özelliklerin tamamını seçmelisiniz");
    }

    //IF VARIANTS ARE NOT FULLY SELECTED SET ALERT
    if (
      variants.fullVariantsArray.length !== choosenVariants.length &&
      !variants.singleSku
    ) {
      return setVariantAlert({
        index: choosenVariants.length === 0 ? 0 : choosenVariants.length,
        message: "Özellik seçmelisiniz!",
      });
    }

    //IF QTY IS NOT SELECTED SET ALERT
    if (qty === 0 || qty === "0") {
      return setQtyAlert("Lütfen adet seçiniz");
    }

    //BUY ONE GET ONE FREE COMPARISON
    else if (
      buyOneGetOneFree &&
      isCampaignedProductInStock &&
      cartSkuItems.length >= 1 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productScreen",
          discounted,
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );

      setDisableButton(true);
      return setBuyOneGetOneFreeRequested(true);
    } else if (buyOneGetOneFree && isCampaignedProductInStock) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productScreen",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );

      setDisableButton(true);
      return setBuyOneGetOneFreeRequested(true);
    }

    //STANDART COMPARISON
    if (
      cartSkuItems.length === 0 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productScreen",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );
      history.push(`/sepet`);
    } else if (
      cartSkuItems.length >= 1 &&
      cartSkuItems[0].sku === (variants.singleSku || multiSku) &&
      productId &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productScreen",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );
      history.push(`/sepet`);
    } else if (
      cartSkuItems.length >= 1 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productScreen",
          discounted,
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );
      history.push(`/sepet`);
    }
  }

  // Fill ErcModal content
  const freeAddToCart = [];
  freeAddToCart.push(
    <FreeProductAddToCart
      loadingCampaign={loadingCampaign}
      errorCampaign={errorCampaign}
      product={productCampaign}
      cartSkuItems={cartSkuItems}
      qty={qty}
      index={0}
      setVariantAlert={setVariantAlert}
      setNoSkuAlert={setNoSkuAlert}
      isThereApendingOrder={isPending && isPending.isTherePending}
    />
  );

  // FILTER showcaseReviews
  const [showcaseReviews, setShowcaseReviews] = useState([]);
  useEffect(() => {
    if (reviewsList?.length > 0 && product) {
      const showcaseReviewIds = product.showcaseReviews;

      const showcaseReviews = reviewsList.filter((review) =>
        showcaseReviewIds.find((reviewId) => reviewId === review._id)
      );

      setShowcaseReviews(showcaseReviews);
    }
  }, [reviewsList, product]);

  // BRING IN LAST MONTH SALES
  const { lastMonthsTotalSale } = useCalculateLastMonthsSales(product);

  return (
    <>
      {loading ? (
        <SuspenseFallback></SuspenseFallback>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        product && (
          <>
            <Helmet>
              <title>Şimdi İncele | {product.name}</title>
              <meta name="description" content={product.metaDescription} />
              <meta name="keywords" content={product.metaKeywords} />
              <meta name="author" content="beddo™ Marketing Team" />
              <meta name="application-name" content="beddo™ ERP" />
            </Helmet>

            <ErcModal
              modalTitleDivWidth={"85%"}
              modalTitle={() => ""}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={""}
              content={freeAddToCart}
              modalParagFontSize={"1.25rem"}
              disableModalTitle={true}
              clickOutsideShouldWork={false}
              callThisFunctionInCloseModalFunction={() => {
                return [
                  resetCartIfFreeProductNotAddedInCart(product),
                  dispatch({ type: CART_EMPTY_SKU }),

                  setDisableButton(false),
                ];
              }}
              popOnMount={
                buyOneGetOneFreeRequested &&
                !loading &&
                !loadingSkuData &&
                cartSkuItems.length > 0
                  ? "OPEN"
                  : "CLOSE"
              } // IF OPEN MODAL POPS IF CLOSE MODAL CLOSE
            />

            <div className="product-details-outer">
              <div className="product-details-main-row">
                <div className="product-details-image-container">
                  <div className="product-feature-message">
                    {isCampaignedProductInStock && (
                      <MessageProductFeature product={product} />
                    )}
                  </div>

                  {/*COMPARING SCREEN SIZES TO AVOID FAULT IN MOBILE DEVICES */}
                  {!multiSku && width > 550 ? (
                    <ImageMagnifier
                      src={product.defaultImages[galeryLargeImage]}
                      alt={product.name}
                      width={"500px"}
                      height={"500px"}
                      zoomLevel={5}
                      magnifierHeight={200}
                      magnifieWidth={200}
                    />
                  ) : loadingSkuData && width > 550 ? (
                    <div style={{ height: "500px" }} className="col">
                      <LoadingBoxWithoutText />
                    </div>
                  ) : errorSkuData && width > 550 ? (
                    <MessageBox varaint="danger">{errorSkuData}</MessageBox>
                  ) : skuData && width > 550 ? (
                    <ImageMagnifier
                      src={skuData.skus[0].skuImages[galeryLargeImage]}
                      alt={product.name}
                      width={"500px"}
                      height={"500px"}
                      zoomLevel={5}
                      magnifierHeight={200}
                      magnifieWidth={200}
                    />
                  ) : !multiSku && width > 325 && width < 550 ? (
                    <ImageMagnifier
                      src={product.defaultImages[galeryLargeImage]}
                      alt={product.name}
                      width={"300px"}
                      height={"300px"}
                      zoomLevel={5}
                      magnifierHeight={200}
                      magnifieWidth={200}
                    />
                  ) : loadingSkuData && width > 325 && width < 550 ? (
                    <div style={{ height: "300px" }} className="col">
                      <LoadingBoxWithoutText />
                    </div>
                  ) : errorSkuData && width > 325 && width < 550 ? (
                    <MessageBox varaint="danger">{errorSkuData}</MessageBox>
                  ) : skuData && width > 325 && width < 550 ? (
                    <ImageMagnifier
                      src={skuData.skus[0].skuImages[galeryLargeImage]}
                      alt={product.name}
                      width={"300px"}
                      height={"300px"}
                      zoomLevel={5}
                      magnifierHeight={200}
                      magnifieWidth={200}
                    />
                  ) : !multiSku && width < 325 ? (
                    <ImageMagnifier
                      src={product.defaultImages[galeryLargeImage]}
                      alt={product.name}
                      width={"200px"}
                      height={"200px"}
                      zoomLevel={5}
                      magnifierHeight={75}
                      magnifieWidth={75}
                    />
                  ) : loadingSkuData && width < 325 ? (
                    <div style={{ height: "200px" }} className="col">
                      <LoadingBoxWithoutText />
                    </div>
                  ) : errorSkuData && width < 325 ? (
                    <MessageBox varaint="danger">{errorSkuData}</MessageBox>
                  ) : skuData && width < 325 ? (
                    <ImageMagnifier
                      src={skuData.skus[0].skuImages[galeryLargeImage]}
                      alt={product.name}
                      width={"200px"}
                      height={"200px"}
                      zoomLevel={5}
                      magnifierHeight={75}
                      magnifieWidth={75}
                    />
                  ) : (
                    ""
                  )}
                  {/* ENDS HERE - COMPARING SCREEN SIZES*/}
                  <ul className="galery-images-holder">
                    {multiSku
                      ? loadingSkuData
                        ? ""
                        : errorSkuData
                        ? ""
                        : skuData &&
                          skuData.skus[0].skuImages.map((image, index) => {
                            return (
                              <li key={image}>
                                <img
                                  className={
                                    image ===
                                    skuData.skus[0].skuImages[galeryLargeImage]
                                      ? "galery-images pointer beddo-border-3"
                                      : "galery-images pointer"
                                  }
                                  src={image}
                                  alt={product.name}
                                  onClick={() =>
                                    handleGaleryLargeImage(index, image)
                                  }
                                />
                              </li>
                            );
                          })
                      : product.defaultImages.map((image, index) => {
                          return (
                            <li key={image}>
                              <img
                                className={
                                  image ===
                                  product.defaultImages[galeryLargeImage]
                                    ? "galery-images pointer beddo-border-3"
                                    : "galery-images pointer"
                                }
                                src={image}
                                alt={product.name}
                                onClick={() =>
                                  handleGaleryLargeImage(index, image)
                                }
                              />
                            </li>
                          );
                        })}
                  </ul>
                </div>
                <div className="product-details-under-image-section lightbck light-green-border">
                  <div className="w90p">
                    <h1 className="fs125 bold lightbck marupsideh padupsideh5">
                      {price && price.name}
                    </h1>
                  </div>
                  <div className="col w100p">
                    <div className="fs-85 row-nowrap beddo-border-bottom w90p">
                      <Rating
                        value={product.rating}
                        text={
                          product.numReviews > 0 && ` (${product.numReviews}) `
                        }
                        reviews={
                          loadingReviewsList
                            ? ""
                            : errorReviewsList
                            ? ""
                            : reviewsList
                        }
                        hover={true}
                      />
                      <Link
                        className="nodeco marsideq linkblue"
                        to={`/yorumlar/${convertToUrl(product.name)}/${
                          product._id
                        }?product=${product.name}?image=${
                          product.defaultImages[0]
                        }`}
                      >
                        <h2 className="fs1">Yorumları Oku</h2>
                      </Link>
                    </div>
                    {lastMonthsTotalSale > 100 && (
                      <LastMonthTotalSales
                        lastMonthsTotalSale={lastMonthsTotalSale}
                      />
                    )}
                  </div>

                  <div className="col marupside1 w90p padupsideh-5">
                    <Link
                      className="nodeco absolute"
                      to={`/sorucevap/${convertToUrl(product.name)}/${
                        product._id
                      }?product=${product.name}?image=${
                        product.defaultImages[0]
                      }`}
                    >
                      <h2 className="fs1 linkblue">
                        Ürün Soruları / Soru Sorun{" "}
                        {qna && qna.count > 0 && (
                          <span className="grey">({qna && qna.count})</span>
                        )}
                      </h2>
                    </Link>
                  </div>

                  <PurchaseComponent
                    isPending={isPending}
                    qty={qty}
                    price={price}
                    isDiscountValid={isDiscountValid}
                    remainingTime={remainingTime}
                    cartSkuItems={cartSkuItems}
                    product={product}
                    variants={variants}
                    setChoosenVariants={setChoosenVariants}
                    choosenVariants={choosenVariants}
                    setVariantAlert={setVariantAlert}
                    variantAlert={variantAlert}
                    setNoSkuAlert={setNoSkuAlert}
                    qtyAlert={qtyAlert}
                    setQty={setQty}
                    setQtyAlert={setQtyAlert}
                    disableButton={disableButton}
                    addToCartHandler={addToCartHandler}
                    noSkuAlert={noSkuAlert}
                    sideProductsRef={sideProductsRef}
                    productCampaign={productCampaign}
                    loadingProduct={loading}
                    errorProduct={error}
                    width={width}
                    skuData={skuData}
                    createdFingerPrint={createdFingerPrint}
                    loadingSideProducts={loadingSideProducts}
                    errorSideProducts={errorSideProducts}
                    sideProducts={sideProducts}
                  />
                </div>
              </div>
            </div>
          </>
        )
      )}

      {showcaseReviews?.length > 0 && (
        <ShowcaseReviews
          product={product}
          showcaseReviews={showcaseReviews}
          reviewsList={reviewsList}
        />
      )}

      {product?.productQuestions?.length > 0 && (
        <FrequentlyAskedQuestions
          product={product}
          questions={product?.productQuestions}
        />
      )}

      {product?.sideProducts?.length > 0 && (
        <SideProductSlideShow
          loading={loadingSideProducts}
          sideProducts={sideProducts}
        />
      )}

      {loading ? (
        ""
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <LongProductDescription product={product} />
      )}
    </>
  );
}
